import { apiClient } from './apiClient';
import type { Product, CreateProductRequest, UpdateProductRequest, ProductResponse } from '../types/product';

export const productService = {
  /**
   * Get all products for a business profile
   */
  async getProducts(businessProfileId: string, token: string): Promise<Product[]> {
    return apiClient.get<Product[]>(`/business-profile/${businessProfileId}/products`, token);
  },

  /**
   * Get a single product by ID
   */
  async getProduct(businessProfileId: string, productId: string, token: string): Promise<Product> {
    return apiClient.get<Product>(`/business-profile/${businessProfileId}/products/${productId}`, token);
  },

  /**
   * Create a new product
   */
  async createProduct(businessProfileId: string, data: CreateProductRequest, token: string): Promise<ProductResponse> {
    return apiClient.post<ProductResponse>(`/business-profile/${businessProfileId}/products`, data, token);
  },

  /**
   * Update an existing product
   */
  async updateProduct(
    businessProfileId: string,
    productId: string,
    data: UpdateProductRequest,
    token: string
  ): Promise<ProductResponse> {
    return apiClient.put<ProductResponse>(`/business-profile/${businessProfileId}/products/${productId}`, data, token);
  },

  /**
   * Delete a product
   */
  async deleteProduct(businessProfileId: string, productId: string, token: string): Promise<void> {
    return apiClient.delete(`/business-profile/${businessProfileId}/products/${productId}`, token);
  },
};
